
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#E2E2E2"}}),_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#333"}},[_c('path',{attrs:{"d":"M16.357 17.341a3.704 3.704 0 10.002-7.407 3.704 3.704 0 00-.002 7.407zm5.308-3.703a5.307 5.307 0 01-5.308 5.307 5.307 5.307 0 110-10.613 5.307 5.307 0 015.308 5.306z"}}),_c('path',{attrs:{"d":"M13.172 16.827a.801.801 0 010 1.134L9.7 21.43a.802.802 0 01-1.134-1.134l3.47-3.47a.802.802 0 011.135 0z"}})])])
          )
        }
      }
    